import { cn } from '../../lib/utils'

interface LogoProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  /** 로고 옆 "Heinrich" 텍스트 노출 여부 (기본 true) */
  showText?: boolean
}

const sizeMap = {
  sm: { height: 32, wrapperClass: 'h-8',  textClass: 'text-lg',  barH: 2,   barTopPx: 2 },
  md: { height: 48, wrapperClass: 'h-12', textClass: 'text-2xl', barH: 2.5, barTopPx: 3 },
  lg: { height: 72, wrapperClass: 'h-[72px]', textClass: 'text-4xl', barH: 3.5, barTopPx: 5 },
}

// KIPO 워드마크 색상 — 워드마크 PNG (09_heinrich_wordmark_KIPO.png) 와 동일한 골드/브론즈 톤
const WORDMARK_BAR_COLOR = '#B88539'

export default function Logo({ size = 'md', className, showText = true }: LogoProps) {
  const { height, wrapperClass, textClass, barH, barTopPx } = sizeMap[size]

  return (
    <div className={cn('inline-flex items-center gap-2.5', wrapperClass, className)}>
      <img
        src="/assets/saife-logo.png"
        alt="Heinrich"
        height={height}
        className="h-full w-auto object-contain"
        draggable={false}
      />
      {showText && (
        <span
          className={cn(
            'font-bold tracking-tight text-ink select-none leading-none',
            'relative inline-block',
            textClass,
          )}
          style={{
            // Liberation Serif (Linux 기본) → Tinos (Google Fonts, 호환 메트릭) → Times New Roman → serif
            fontFamily: '"Liberation Serif", "Tinos", "Times New Roman", serif',
            // 텍스트 아래 골드 바 (KIPO 워드마크 스타일) — pseudo 대신 inline border-bottom 으로 자식 요소 처리
            paddingBottom: `${barTopPx + barH + 1}px`,
          }}
        >
          Heinrich
          <span
            aria-hidden="true"
            className="absolute pointer-events-none rounded-full"
            style={{
              left: '50%',
              transform: 'translateX(-50%)',
              bottom: `${barTopPx}px`,
              width: '55%',
              height: `${barH}px`,
              backgroundColor: WORDMARK_BAR_COLOR,
            }}
          />
        </span>
      )}
    </div>
  )
}
